import LogoAlphalitical from 'src/assets/image/logo_alphalitical.png';
import LogoNoLimit from 'src/assets/image/nolimit-logo-flat.svg';
import LogoNoLimitWhite from 'src/assets/image/logoNoLimitWhite.svg';
import LogoPdip from 'src/assets/image/logo_pdip.png';
import LogoKabCiamis from 'src/assets/image/logo_kabciamis.png';
import LogoKemhan from 'src/assets/image/logo_kemenhan.png';
import LogoBais from 'src/assets/image/logo_bais.png';
import LogoKadence from 'src/assets/image/logo_kadence.png';
import LogoKadenceWhite from 'src/assets/image/logo_kadence_white.png';
import logoKompas from 'src/assets/image/logo_kompas.png';
import logoSkema from 'src/assets/image/logo_skema.png';
import logoGcomm from 'src/assets/image/logo_gcomm.png';
import logoGcommWhite from 'src/assets/image/logo_gcomm_white.png';
import logoPln from 'src/assets/image/logo_pln.png';
import logoPlnWhite from 'src/assets/image/logo_pln_white.png';
import tniAuLogo from 'src/assets/image/tni-au-logo.png';
import tniAuLogoWhite from 'src/assets/image/tni-au-logo-white.png';
import telAccessLogo from 'src/assets/image/logo_tel_access.png';
import telAccessLogoWhite from 'src/assets/image/logo_tel_access_white.png';
import logoDiy from 'src/assets/image/logo_diy.png';
import logoBbdo from 'src/assets/image/logo_bbdo.png';
import logoValdo from 'src/assets/image/valdo-logo.png';
import logoValdoWhite from 'src/assets/image/valdo-logo-white.png';
import transparentLogo from 'src/assets/image/transparent-logo.png';
import garudaLogo from 'src/assets/image/logo-garuda-hd-34025.png';
import sporaLogo from 'src/assets/image/logo-spora.png';
import sporaLogoWhite from 'src/assets/image/logo-spora-white.png';
import logoUpn from 'src/assets/image/logo-upn.png';
import logoPerisai from 'src/assets/image/logo-perisai.png';
import logoPerisaiWhite from 'src/assets/image/logo-perisai-white.jpg';
import logoAntara from 'src/assets/image/antara-logo.png';
import logoAntaraWhite from 'src/assets/image/antara-logo-white.png';
import logoKpsg from 'src/assets/image/logo-kpsg.png';
import logoKpsgDark from 'src/assets/image/kpsg_upscaled.png';
import logoTelkomsel from 'src/assets/image/telkomsel-logo.png';
import logoTelkomselWhite from 'src/assets/image/telkomsel-logo-white.png';
import logoCitiasia from 'src/assets/image/citiasia-logo.png';
import logoVybemedia from 'src/assets/image/vybemedia-logo.png';
import logoVybemediaBg from 'src/assets/image/vybemedia-with-bg.png';

export const getLogoByHostname = function (isLogin?: boolean) {
  const isUpn =
    window.location.hostname.includes('integdig') ||
    window.location.hostname.includes('cakrawala');

  if (window.location.hostname.includes('alphalitical')) {
    return { logo: LogoAlphalitical, width: isLogin ? '120px' : '80px' };
  }
  if (window.location.hostname.includes('pdip')) {
    return { logo: LogoPdip, width: isLogin ? '70px' : '50px' };
  }
  if (window.location.hostname.includes('pemkabciamis')) {
    return { logo: LogoKabCiamis, width: isLogin ? '72px' : '55px' };
  }
  if (window.location.hostname.includes('kemhan')) {
    return { logo: LogoKemhan, width: isLogin ? '70px' : '50px' };
  }
  if (window.location.hostname.includes('legasysolution'))
    return { logo: LogoBais, width: isLogin ? '70px' : '60px' };

  if (window.location.hostname.includes('kadence') && isLogin)
    return { logo: LogoKadence, width: '141px' };

  if (window.location.hostname.includes('kadence'))
    return { logo: LogoKadenceWhite, width: '140px' };

  if (window.location.hostname.includes('kompas'))
    return { logo: logoKompas, width: '150px' };

  if (window.location.hostname.includes('skema'))
    return { logo: logoSkema, width: '100px' };

  if (window.location.hostname.includes('gcomm')) {
    if (isLogin) return { logo: logoGcomm, width: '100px' };
    return { logo: logoGcommWhite, width: '100px' };
  }

  if (window.location.hostname.includes('ps-techno')) {
    if (isLogin) return { logo: logoPln, width: '100px' };
    return { logo: logoPlnWhite, width: '100px' };
  }

  if (window.location.hostname.includes('tni-au')) {
    if (isLogin) return { logo: tniAuLogo, width: '150px' };
    return { logo: tniAuLogoWhite, width: '150px' };
  }
  if (window.location.hostname.includes('tel-access')) {
    return {
      logo: isLogin ? telAccessLogo : telAccessLogoWhite,
      width: isLogin ? '120px' : '90px'
    };
  }
  if (window.location.hostname.includes('elingjogja')) {
    return { logo: logoDiy, width: isLogin ? '120px' : '90px' };
  }
  if (window.location.hostname.includes('bbdo')) {
    return { logo: logoBbdo, width: '150px' };
  }

  if (window.location.hostname.includes('valdo')) {
    if (isLogin) return { logo: logoValdo, width: '150px' };
    return { logo: logoValdoWhite, width: '150px' };
  }

  if (window.location.hostname.includes('nxdev')) {
    if (isLogin) return { logo: transparentLogo, width: '80px' };
    return { logo: transparentLogo, width: '80px' };
  }

  if (window.location.hostname.includes('presiden')) {
    if (isLogin) return { logo: garudaLogo, width: '80px' };
    return { logo: garudaLogo, width: '60px' };
  }

  if (window.location.hostname.includes('spora')) {
    if (isLogin) return { logo: sporaLogo, width: '150px' };
    return { logo: sporaLogoWhite, width: '130px' };
  }

  if (isUpn) {
    if (isLogin) return { logo: logoUpn, width: '120px' };
    return { logo: logoUpn, width: '60px' };
  }

  if (window.location.hostname.includes('perisai')) {
    if (isLogin) return { logo: logoPerisai, width: '200px' };
    return { logo: logoPerisaiWhite, width: '120px' };
  }

  if (window.location.hostname.includes('antaranews')) {
    if (isLogin) return { logo: logoAntara, width: '150px' };
    return { logo: logoAntaraWhite, width: '120px' };
  }

  if (window.location.hostname.includes('kpsg')) {
    if (isLogin) return { logo: logoKpsg, width: '150px' };
    return { logo: logoKpsgDark, width: '50px' };
  }

  if (
    window.location.hostname.includes('tsight') ||
    window.location.hostname.includes('sentrix')
  ) {
    if (isLogin) return { logo: logoTelkomsel, width: '150px' };
    return { logo: logoTelkomselWhite, width: '120px' };
  }

  if (window.location.hostname.includes('citiasiainc')) {
    if (isLogin) return { logo: logoCitiasia, width: '180px' };
    return { logo: logoCitiasia, width: '120px' };
  }

  if (window.location.hostname.includes('vybemedia')) {
    if (isLogin) return { logo: logoVybemedia, width: '120px' };
    return { logo: logoVybemediaBg, width: '60px' };
  }

  if (isLogin) return { logo: LogoNoLimit, width: 'auto' };
  return { logo: LogoNoLimitWhite, width: '94.97px' };
};
